/*
  Mije Seoul — FAQ page behaviour (pt2 Screen 6): anchor-rail scrollspy.
  Accordions are native <details> (PDP pattern) — no JS needed.
*/

(function () {
  'use strict';

  var anchors = document.querySelectorAll('[data-faq-anchor]');
  var groups = document.querySelectorAll('[data-faq-group]');
  if (!anchors.length || !groups.length) return;

  function setActive(id) {
    anchors.forEach(function (a) {
      a.classList.toggle('is-active', a.dataset.faqAnchor === id);
    });
  }

  /* active = the last group whose top has crossed the reading line (~1/4 down) */
  var ticking = false;

  function spy() {
    ticking = false;
    var line = window.innerHeight * 0.25;
    var current = groups[0].id;
    groups.forEach(function (g) {
      if (g.getBoundingClientRect().top <= line) current = g.id;
    });
    setActive(current);
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(spy);
      }
    },
    { passive: true }
  );
  spy();

  anchors.forEach(function (a) {
    a.addEventListener('click', function () {
      setActive(a.dataset.faqAnchor);
    });
  });
})();
